import moment from 'moment';
import constants from '@/shared/constants/constants';
import i18n from '@/plugins/i18n';

export function priceFormatted(dataPlan, lang = constants.LANGUAGE_JA, plan = constants.PLAN, countryUser = constants.COUNTRY_USER_JP) {
  const langFormat = [constants.LANGUAGE_JA, constants.LANGUAGE_CN].includes(lang) ? lang : constants.LANGUAGE_EN;
  const dataPrice = dataPlan ? getDataPrice(dataPlan, countryUser) : 0;
  if (dataPrice.price) {
    let valueFormat = dataPrice.price;
    let unit = i18n.t(dataPrice.key_unit, langFormat);
    const currency = i18n.t(dataPrice.key_currency, langFormat);
    let durationUnit = i18n.t('status_table.sheet', langFormat);

    if (
      [constants.COUNTRY_USER_JP, constants.COUNTRY_USER_OT].includes(countryUser) &&
      langFormat === constants.LANGUAGE_JA &&
      (/0000$/.test(valueFormat) || dataPrice.type === constants.PLAN_TYPE_ADHOC)
    ) {
      valueFormat /= 10000;
      unit = i18n.t('unit_man', langFormat);
    }
    if (dataPrice.type === constants.PLAN_TYPE_ADHOC) {
      durationUnit = i18n.t('project_image', langFormat);
    }
    if (
      (plan === constants.PLAN && dataPrice.type === constants.PLAN_TYPE_BY_MONTH) || plan === constants.PLAN_GENERATE
    ) {
      valueFormat /= dataPrice.validity_period;
      if ((valueFormat * 10) % 10 !== 0) {
        valueFormat = valueFormat.toFixed(langFormat === constants.LANGUAGE_JA ? 1 : 0);
      }
      if (plan === constants.PLAN_GENERATE && dataPrice.type === constants.PLAN_GENERATE_TYPE_DAY) {
        // 1-day plan: display price per user/day (no max_accounts unit shown)
        if (dataPlan.id === constants.PLAN_GENERATE_1_DAY_ID) {
          durationUnit = i18n.t('plan_per_user_day', langFormat);
        } else {
          durationUnit = i18n.t('login_count_table.day', langFormat);
        }
      } else {
        durationUnit = i18n.t('login_count_table.month', langFormat);
      }
    }

    const separator = (dataPlan && dataPlan.id === constants.PLAN_GENERATE_1_DAY_ID && langFormat === constants.LANGUAGE_JA) ? '・' : '/';
    return `${currency}${valueFormat.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${unit}${separator}${durationUnit}`;
  }

  return i18n.t('plan_free', langFormat);
}

export function formatPrice(dataPlan, lang = constants.LANGUAGE_JA, countryUser = constants.COUNTRY_USER_JP, numImage = 1) {
  const langFormat = [constants.LANGUAGE_JA, constants.LANGUAGE_CN].includes(lang) ? lang : constants.LANGUAGE_EN;
  const dataPrice = dataPlan ? getDataPrice(dataPlan, countryUser) : 0;
  let valueFormat = dataPrice.price * numImage;
  let unit = i18n.t(dataPrice.key_unit, langFormat);
  const currency = i18n.t(dataPrice.key_currency, langFormat);

  if (
    [constants.COUNTRY_USER_JP, constants.COUNTRY_USER_OT].includes(countryUser) &&
    langFormat === constants.LANGUAGE_JA &&
    (/0000$/.test(valueFormat) || dataPrice.type === constants.PLAN_TYPE_ADHOC)
  ) {
    valueFormat /= 10000;
    unit = i18n.t('unit_man', langFormat);
  }
  return `${currency}${valueFormat.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${unit}`;
}

export function formatPriceAnalysis(numImage) {
  let valueFormat = constants.PRICE_ANALYSIS * numImage;
  let unit = i18n.t('unit', constants.LANGUAGE_JA);
  if (/000$/.test(valueFormat)) {
    valueFormat /= 10000;
    unit = i18n.t('unit_man', constants.LANGUAGE_JA);
  }
  return `${valueFormat.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${unit}`;
}

export function formatPriceDefault(priceDefault = 0, dataPlan = null, lang = constants.LANGUAGE_JA, countryUser = constants.COUNTRY_USER_JP, numImage = 1) {
  const langFormat = [constants.LANGUAGE_JA, constants.LANGUAGE_CN].includes(lang) ? lang : constants.LANGUAGE_EN;
  let valueFormat = priceDefault * numImage;
  let unit = i18n.t('unit', langFormat);
  let currency = i18n.t('currency', langFormat);
  if (dataPlan) {
    const dataPrice = getDataPrice(dataPlan, countryUser);
    unit = i18n.t(dataPrice.key_unit, langFormat);
    currency = i18n.t(dataPrice.key_currency, langFormat);
    valueFormat = dataPrice.price * numImage;
  }

  if (valueFormat) {
    return `${currency}${valueFormat.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${unit}`;
  }
  return null;
}

function isNotFeePlanForAmount(data) {
  if (data.plan && constants.PLAN_TYPE_NOT_FEE.includes(data.plan.plan_type)) {
    return true;
  }
  // Trial generate (formerly generate free) — hide amounts same as trial valuation
  const generatePlanId = data.plan_generate ? data.plan_generate.plan_generate_id : null;
  return generatePlanId === constants.PLAN_GENERATE_FREE_ID;
}

export function formatPriceByField(data, field, amountSetting, lang = constants.LANGUAGE_JA) {
  const langFormat = [constants.LANGUAGE_JA, constants.LANGUAGE_CN].includes(lang) ? lang : constants.LANGUAGE_EN;
  if (amountSetting.length > 0) {
    const setting = amountSetting.find(item => item.country === data.country);
    if (!setting || !setting.status) {
      return constants.DATA_HIDDEN;
    }
  }
  let money = data[field];
  if (
    data.role !== constants.ROLE_ADMIN ||
    (isNotFeePlanForAmount(data) && !data.request_payment)
  ) {
    return constants.DATA_HIDDEN;
  }
  const countryUser = data.country;
  // const dataPrice = getDataPrice(data.plan, data.country);
  const dataPrice = data.plan ? getDataPrice(data.plan, countryUser) : data.plan_generate ? getDataPrice(data.plan_generate, countryUser) : 0;

  let unit = i18n.t(dataPrice.key_unit, langFormat);
  const currency = i18n.t(dataPrice.key_currency, langFormat);
  if ([constants.COUNTRY_USER_JP, constants.COUNTRY_USER_OT].includes(countryUser) && /000$/.test(money) && langFormat === constants.LANGUAGE_JA) {
    money /= 10000;
    unit = i18n.t('unit_man', constants.LANGUAGE_JA);
  }
  return `${currency}${money.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${unit}`;
}

export function formatPriceByField2(money, dataPlan, dataPlanGenerate, lang = constants.LANGUAGE_JA, user, amountSetting, countryUser) {
  if (amountSetting.length > 0) {
    const setting = amountSetting.find(item => item.country === user.country);
    if (!setting || !setting.status) {
      return constants.DATA_HIDDEN;
    }
  }
  if (!money) return '';
  let moneyFormat = money;
  const langFormat = [constants.LANGUAGE_JA, constants.LANGUAGE_CN].includes(lang) ? lang : constants.LANGUAGE_EN;
  const dataPrice = dataPlan ? getDataPrice(dataPlan, countryUser) : dataPlanGenerate ? getDataPrice(dataPlanGenerate, countryUser) : 0;
  let unit = i18n.t(dataPrice.key_unit, langFormat);
  const currency = i18n.t(dataPrice.key_currency, langFormat);
  if ([constants.COUNTRY_USER_JP, constants.COUNTRY_USER_OT].includes(countryUser) && lang === constants.LANGUAGE_JA && /000$/.test(money)) {
    moneyFormat /= 10000;
    unit = i18n.t('unit_man', langFormat);
  }
  return `${currency}${moneyFormat.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}${unit}`;
}

export function validityPeriodFormatted(value, type, lang = 'ja') {
  if (value) {
    let unit = '';
    if (type === 'weeks') {
      unit = i18n.t('plan_week', lang);
    } else if (type === 'days') {
      unit = i18n.t('plan_days', lang);
    } else {
      unit = i18n.t('plan_months', lang);
    }

    if (value >= 12) {
      value /= 12;
      unit = i18n.t('plan_year', lang);
    }
    return `${value}${unit}`;
  }

  return i18n.t('plan_none', lang);
}

/**
 * Helper function to format validity period with month/year conversion
 * @returns {string} Formatted string with value and unit
 */
function formatValidityPeriodWithYearConversion(value, unitKey, lang = 'ja') {
  let unit = i18n.t(unitKey, lang);
  let formattedValue = value;

  // Convert to year if value >= 12 and unit is month-based
  if (value >= 12 && unitKey === 'plan_month') {
    formattedValue = value / 12;
    unit = i18n.t('plan_year', lang);
  }

  return `${formattedValue}${unit}`;
}

/**
 * Formats validity period for plan confirmation (month/year only)
 * @returns {string} Formatted string with value and unit, or 'no_expiration' message if value is falsy
 */
export function validityPeriodConfirmFormatted(value, lang = 'ja') {
  if (value) {
    return formatValidityPeriodWithYearConversion(value, 'plan_month', lang);
  }

  return i18n.t('no_expiration', lang);
}

/**
 * Formats validity period for plan generate with support for day/month/year units
 * @returns {string} Formatted string with value and unit, or same fallback as valuation plan table (`plan_none`) when falsy
 */
export function validityPeriodPlanGenerateFormatted(type, value, lang = 'ja') {
  if (value) {
    // Default to MONTH type if type is undefined/null/invalid
    const planType = type === constants.PLAN_GENERATE_TYPE_DAY
      ? constants.PLAN_GENERATE_TYPE_DAY
      : constants.PLAN_GENERATE_TYPE_MONTH;

    if (planType === constants.PLAN_GENERATE_TYPE_DAY) {
      const unit = i18n.t('plan_days', lang);
      return `${value}${unit}`;
    } else {
      // MONTH type - use helper function for year conversion
      return formatValidityPeriodWithYearConversion(value, 'plan_month', lang);
    }
  }

  return i18n.t('plan_none', lang);
}

export function dateFormatted(value, short = '') {
  let format;
  let date;

  if (short === '') {
    format = 'YYYY.M.D';
  } else {
    format = short;
  }

  if (value) {
    date = typeof value === 'number' ? moment.unix(value) : moment(value);

    if (date !== 'Invalid Date') {
      return date.format(format);
    }
  }

  return '';
}

export function getYear(value) {
  let date;

  if (value) {
    date = moment(value);

    if (date !== 'Invalid Date') {
      return date.year();
    }
  }

  return '';
}

export function getMonth(value) {
  let date;

  if (value) {
    date = moment(value);

    if (date !== 'Invalid Date') {
      return date.month() + 1;
    }
  }

  return '';
}

export function formatEnglishOrdinal(value) {
  const n = typeof value === 'number' ? value : parseInt(value, 10);
  if (!Number.isFinite(n) || n <= 0) return value;
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 13) return `${n}th`;
  switch (n % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
    default:
      return `${n}th`;
  }
}

export function excerpt(string = '', length = 10, more = '...') {
  string = String(string).trim();

  if (string.length > length) {
    return `${string.substr(0, length)}${more}`;
  }

  return string;
}

export function getDataPrice(dataPlan, countryUser) {
  let value = dataPlan.price;

  let keyUnit = 'unit';
  let keyCurrency = 'currency';
  const type = dataPlan.plan_type ? dataPlan.plan_type : dataPlan.type;
  if (countryUser === constants.COUNTRY_USER_CN) {
    value = dataPlan.price_cn;
    keyUnit = 'unit_cn';
    keyCurrency = 'currency_cn';
  } else if (countryUser === constants.COUNTRY_USER_TH) {
    value = dataPlan.price_th;
    keyUnit = 'unit_th';
    keyCurrency = 'currency_th';
  } else if (countryUser === constants.COUNTRY_USER_ID) {
    value = dataPlan.price_id;
    keyUnit = 'unit_id';
    keyCurrency = 'currency_id';
  }
  const validityPeriod = dataPlan.validity_period;

  return {
    price: value,
    key_unit: keyUnit,
    key_currency: keyCurrency,
    type,
    validity_period: validityPeriod,
  };
}

export function formatMaxImage(user, maxImageSetting, showDataHidden = false) {
  if (maxImageSetting.length > 0) {
    const setting = maxImageSetting.find(item => item.country === user.country);
    if (setting && setting.status) {
      return user.max_images;
    }
  }
  if (showDataHidden) {
    return constants.DATA_HIDDEN;
  }
  return null;
}
